import { BANNER_ACTION, BANNER_PATH } from '../../constants'
import setReduxAction from '../../../redux/actions/set'

function updateCurrentBannerAction (bannerId, data) {
  return setReduxAction({
    type: bannerId
      ? BANNER_ACTION.OPEN
      : BANNER_ACTION.CLOSE,
    payload: {
      paths: [
        BANNER_PATH.CURRENT,
        BANNER_PATH.DATA
      ],
      values: [
        bannerId,
        data
      ]
    }
  })
}

export default updateCurrentBannerAction
